var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "google-map",
    {
      ref: "map",
      staticClass: "map",
      attrs: {
        center: _vm.center,
        zoom: _vm.zoom,
        options: {
          styles: _vm.mapStyles,
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false
        }
      },
      on: { click: _vm.expandMap }
    },
    _vm._l(_vm.mapMarkers, function(marker) {
      return _c("google-marker", {
        key: marker.id,
        ref: "myMarker",
        refInFor: true,
        attrs: {
          title: marker.title,
          position: marker.position,
          icon: marker.icon,
          label: marker.label,
          visible: marker.visible
        },
        on: {
          click: function($event) {
            return _vm.onMapMarkerClick(marker.id)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }